import { useEffect, useState } from 'react'
import { Dialog } from 'primereact/dialog';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faListOl } from "@fortawesome/free-solid-svg-icons";
import "./TableOfContent.css";

function TableOfContent({ data }) {
    const headings = data;
    const [showButton, setShowButton] = useState(false);
    const [isShow, setIsShow] = useState(false);
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        function handleScroll() {
            const element = document?.getElementById('editor-post');
            if (!element) return;
            const position = element.getBoundingClientRect();
            if (position.top <= 40 && position.bottom >= 450) {
                setShowButton(true);
            } else {
                setShowButton(false)
            }
        }
        document.addEventListener('scroll', handleScroll);
        return () => {
            document.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleScrollContent = (id) => {
        const headerElement = document.querySelector(`[data-header="${id}"]`);
        if (headerElement) {
            headerElement.scrollIntoView({
                behavior: "instant",
                block: 'start',
            });
        } else {
            console.error("Không tìm thấy phần tử có data-header:", id);
        }
    }
    

    return (
        <>
            <div id="table-content" className="mb-4 mx-1 font-bold border box-shadow h-auto"
                style={{ marginTop: 10, backgroundColor: "#e5e7eb", cursor: "pointer" }}
            >
                <div className="mx-1" style={{ paddingBottom: "10px" }}>
                    <div className='mb-4 pl-3 row' style={{ paddingTop: "15px" }} onClick={() => setIsShow(!isShow)}>
                        <div className="col-sm-11 col-xs-10">
                            <h2 className=" text-4xl">Mục lục</h2>
                        </div>
                        <div className='col-sm-1 col-xs-1 mt-3'>
                            <FontAwesomeIcon icon={faCaretDown} style={{ fontSize: "2.5em" }} />
                        </div>
                    </div>
                    {!isShow ? <div className="my-10 pl-2 pr-3">
                        {headings?.map((heading, index) => {
                            switch (heading.tag) {
                                case "H1" : {
                                    return (
                                        <div key={index}>
                                            <div className="mb-3 w-auto"
                                                style={{ marginLeft: 20, listStyleType: "disc", textAlign: "justify", paddingRight: "40px" }}
                                                key={index}
                                                onClick={(e) => {
                                                    handleScrollContent(heading?.id)
                                                }}
                                            >
                                            <a><span className="text-2xl font-bold"
                                                style={{ cursor: "pointer" }}> {heading?.text}</span></a>
                                            </div>
                                        </div>
                                    )
                                }
                                case "H2" : {
                                    return (
                                        <div key={index}>
                                            <div className="mb-3 w-auto"
                                                style={{ marginLeft: 20, listStyleType: "disc", textAlign: "justify", paddingRight: "40px" }}
                                                key={index}
                                                onClick={(e) => {
                                                    handleScrollContent(heading?.id)
                                                }}
                                            >
                                            <a><span className="text-2xl font-bold"
                                                style={{ cursor: "pointer" }}> {heading?.text}</span></a>
                                            </div>
                                        </div>
                                    )
                                }
                                case "H3" : {
                                    return (
                                        <div key={index}>
                                            <div className="mb-3 w-auto"
                                                style={{ marginLeft: 60, listStyleType: "square", display: "list-item", textAlign: "justify", paddingRight: "40px" }}
                                                key={index}
                                                onClick={(e) => {
                                                    handleScrollContent(heading?.id)
                                                }}
                                            >
                                            <a><span className="text-2xl font-bold"
                                                style={{ cursor: "pointer" }}> {heading?.text}</span></a>
                                            </div>
                                        </div>
                                    )
                                }
                                case "H4" : {
                                    return (
                                        <div key={index}>
                                            <div className="mb-3 w-auto"
                                                style={{ marginLeft: 100, listStyleType: "disc", display: "list-item", textAlign: "justify", paddingRight: "40px" }}
                                                key={index}
                                                onClick={(e) => {
                                                    handleScrollContent(heading?.id)
                                                }}
                                            >
                                            <a><span className="text-2xl font-bold"
                                                style={{ cursor: "pointer" }}> {heading?.text}</span></a>
                                            </div>
                                        </div>
                                    )
                                }
                                default: return ""
                            }
                        })}
                    </div> : ""}
                </div>
            </div>

            <div style={{ paddingLeft: "100%" }}>
                {showButton ?
                    <button type="button" className="toggle-button" data-toggle="modal" data-target="#exampleModal"
                        onClick={() => setVisible(true)}>
                        <FontAwesomeIcon icon={faListOl} className="text-7xl" aria-hidden="true" />
                    </button> : ""}
            </div>

            <Dialog header="Mục lục" visible={visible} onHide={() => setVisible(false)}
                style={{ width: '50vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }}>
                <div className="my-10 pl-2 pr-3">
                {headings?.map((heading, index) => {
                            switch (heading.tag) {
                                case "H1" : {
                                    return (
                                        <div key={index}>
                                            <div className="mb-3 w-auto"
                                                style={{ marginLeft: 20, listStyleType: "disc", textAlign: "justify", paddingRight: "40px" }}
                                                key={index}
                                                onClick={(e) => {
                                                    handleScrollContent(heading?.id)
                                                }}
                                            >
                                            <a><span className="text-2xl font-bold"
                                                style={{ cursor: "pointer" }}> {heading?.text}</span></a>
                                            </div>
                                        </div>
                                    )
                                }
                                case "H2" : {
                                    return (
                                        <div key={index}>
                                            <div className="mb-3 w-auto"
                                                style={{ marginLeft: 20, listStyleType: "disc", textAlign: "justify", paddingRight: "40px" }}
                                                key={index}
                                                onClick={(e) => {
                                                    handleScrollContent(heading?.id)
                                                }}
                                            >
                                            <a><span className="text-2xl font-bold"
                                                style={{ cursor: "pointer" }}> {heading?.text}</span></a>
                                            </div>
                                        </div>
                                    )
                                }
                                case "H3" : {
                                    return (
                                        <div key={index}>
                                            <div className="mb-3 w-auto"
                                                style={{ marginLeft: 60, listStyleType: "square", display: "list-item", textAlign: "justify", paddingRight: "40px" }}
                                                key={index}
                                                onClick={(e) => {
                                                    handleScrollContent(heading?.id)
                                                }}
                                            >
                                            <a><span className="text-2xl font-bold"
                                                style={{ cursor: "pointer" }}> {heading?.text}</span></a>
                                            </div>
                                        </div>
                                    )
                                }
                                case "H4" : {
                                    return (
                                        <div key={index}>
                                            <div className="mb-3 w-auto"
                                                style={{ marginLeft: 100, listStyleType: "disc", display: "list-item", textAlign: "justify", paddingRight: "40px" }}
                                                key={index}
                                                onClick={(e) => {
                                                    handleScrollContent(heading?.id)
                                                }}
                                            >
                                            <a><span className="text-2xl font-bold"
                                                style={{ cursor: "pointer" }}> {heading?.text}</span></a>
                                            </div>
                                        </div>
                                    )
                                }
                                default: return ""
                            }
                        })}
                </div>
            </Dialog>
        </>
    )
}

export default TableOfContent
